/**
 * nxhoa 12.12.2022 ColumnType trong bảng di_payroll_item_column
 */
export default {
  BaseValue: 1, //Hệ số,hoặc tỉ lệ, hoặc số tiền
  Value: 2, //Số tiền cơ bản
  Unbound: 3,
  Deduct_BHXH: 4, // Khấu trừ cho bảo hiểm xã hội
  Deduct_BHYT: 5, // Khấu trừ cho bảo hiểm ý tế
  Deduct_BHTN: 6, // Khấu trừ cho bảo hiểm thất nghiệp
  Deduct_Unbound: 7,
  PercenRate: 8, // Tỉ lệ hưởng
  RealValue: 9, // Thực lĩnh
  BH_KPCD_PercenRate: 11, // Tỷ lệ tính BH, KPCĐ
};

// HS_Luong	Lương ngạch bậc	Luong		1
// Luong	Lương ngạch bậc	Luong		2
// Luong_Unbound	Lương ngạch bậc	Luong		3
// BHXH_Luong	Lương ngạch bậc	Luong		4
// BHYT_Luong	Lương ngạch bậc	Luong		5
// BHTN_Luong	Lương ngạch bậc	Luong		6
// KT_Luong_Unbound	Lương ngạch bậc	Luong		7
// Luong_PercenRate	Lương ngạch bậc	Luong		8
// Luong_RealValue	Lương ngạch bậc	Luong	9
// BH_KPCD_Luong_PercenRate	Lương ngạch bậc	Luong	11
